<template>
  <div>
    <!-- <div
      class="home"
      v-scroll-spy="{ offset: 130 }"
      :style="{ marginTop: `${$store.getters['dom/topMenuOffset']}px` }"
    > -->
    <AppHeader></AppHeader>
    <div class="home" v-scroll-spy="{ offset: 84 }">
      <Hero />
      <Introduction />
      <Benefits />
      <AccountSummary />
      <SeatingMap />
      <Faq />
      <AppFooter />
    </div>
  </div>
</template>
<script>
import AppHeader from "@/layout/Header.vue";
import AppFooter from "@/layout/Footer.vue";
import Hero from "./Hero";
import Introduction from "./Introduction";
import Benefits from "./Benefits";
import SeatingMap from "./SeatingMap";
import AccountSummary from "./AccountSummary";
import Faq from "./Faq";

export default {
  components: {
    AppHeader,
    AppFooter,
    Hero,
    Introduction,
    Benefits,
    SeatingMap,
    AccountSummary,
    Faq,
  },
};
</script>

<style lang="scss" scoped>
</style>